import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { secondsToFormat } from '../../../js/helpers/Utils/formats';
import { infinito } from '../../../Images/NoAvailableSVG';

function TimerCountDown({ timeToRate, lineWidth, colorDown, colorUp, size, showingTimer, fontsize, onTimesUp=()=>{}, showInfinite = true, waitingWrapUp = false,onOneSecondRemaining }) {
  const [propTimeToRate, setTimeToRate] = useState(timeToRate);
  const initialTime = useRef(timeToRate);
  const startDate = useRef(new Date());
  const canvasRef = useRef(null);
  const contextCanvasRef = useRef(null);
  const timerRateRef = useRef(null);

  useEffect(() => {
    startTimer();
  }, [])
  
  useEffect(() => {
    startTimer();
    return () => {
      if (timerRateRef.current) {
        clearInterval(timerRateRef.current);
      }
    }
  }, [waitingWrapUp]);

  function startTimer(){
    const canvas = canvasRef.current;
    if (canvas) {
      const contextCanvas = canvas.getContext('2d');
      contextCanvasRef.current = contextCanvas;
      drawArc(-Math.PI / 2.0, Math.PI * 1.5);
      if (!timerRateRef.current) {
        if (propTimeToRate > 0) {
          setTimer();
        }
        if (propTimeToRate <= 0 && !waitingWrapUp) {
          setTimerUp();
        }
      }
    }
    return () => {
      clearInterval(timerRateRef.current);
      timerRateRef.current = null;
    };
  }

  function setTimer() {
    if (timerRateRef.current) {
      clearInterval(timerRateRef.current);
      timerRateRef.current = null;
    }
    timerRateRef.current = setInterval(timeRate, 1000);
    function timeRate() {
      const currentDate = new Date();
      const seconds = (currentDate - startDate.current) / 1000;
      const remainingSeconds = Math.round(initialTime.current - seconds);
      setTimeToRate(remainingSeconds);
      const startAngle = -Math.PI / 2.0;
      const newAngle = startAngle + (remainingSeconds / initialTime.current) * (Math.PI * 2.0);
      drawArc(startAngle, newAngle);
      if (remainingSeconds <= 1) {
        onOneSecondRemaining();
      }
      if (remainingSeconds <= 0) {
        onTimesUp();
        clearInterval(timerRateRef.current);
      }
    }
  }

  function setTimerUp() {
    if (timerRateRef.current) {
      clearInterval(timerRateRef.current);
      timerRateRef.current = null;
    }
    timerRateRef.current = setInterval(timeRateUp, 1000);
    function timeRateUp() {
      const currentDate = new Date();
      const seconds = (currentDate - startDate.current) / 1000;
      setTimeToRate(seconds);
    }
  }

  function drawArc(startAngle, endAngle) {
    const contextCanvas = contextCanvasRef.current;
    if (!contextCanvas) return;
    if(canvasRef.current === null) return;
    contextCanvas.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    contextCanvas.strokeStyle = '#CDCCCC';
    contextCanvas.fillStyle = 'transparent';
    contextCanvas.lineWidth = lineWidth;
    contextCanvas.beginPath();
    const position = size / 2;
    contextCanvas.arc(position, position, size / 2 - lineWidth / 2, 0, Math.PI * 2.0, false);
    contextCanvas.fill();
    contextCanvas.stroke();
    const gradient = contextCanvas.createLinearGradient(0, 0, 0, 50);
    gradient.addColorStop('0', colorDown);
    gradient.addColorStop('1.0', colorUp);
    contextCanvas.strokeStyle = gradient;
    contextCanvas.fillStyle = 'transparent';
    contextCanvas.lineWidth = lineWidth;
    contextCanvas.beginPath();
    contextCanvas.arc(position, position, size / 2 - lineWidth / 2, startAngle, endAngle, false);
    contextCanvas.fill();
    contextCanvas.stroke();
  }

  return (
    <div className="counterContainer" style={{ width: `${size + 3}px`, height: `${size + 3}px` }}>
      {showingTimer && (
        <div>
          <canvas ref={canvasRef} className="canvasCounter" width={size} height={size} />
          {propTimeToRate === 0 && showInfinite ? (
            <div className="rateTime padding4">{infinito}</div>
          ) : (
            <p className={`rateTime ${fontsize}`} style={{ width: `${size}px`, height: `${size}px` }}>
              {waitingWrapUp ? '00:00:00' : secondsToFormat(propTimeToRate, false)}
            </p>
          )}
        </div>
      )}
    </div>
  );
}

TimerCountDown.propTypes = {
  timeToRate: PropTypes.number.isRequired,
  lineWidth: PropTypes.number.isRequired,
  colorDown: PropTypes.string.isRequired,
  colorUp: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  showingTimer: PropTypes.bool.isRequired,
  fontsize: PropTypes.string.isRequired,
  onTimesUp: PropTypes.func,
};

export default TimerCountDown;


// WEBPACK FOOTER //
// ./src/components/workSpace/Others/TimerCountDown.jsx